import {message as notification} from 'antd';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { authResponse, forgotPasswordResponse, createCustomerResponse} from "./AuthService";
import { mainResponse } from './MainService';
import { stationResponse, response } from './StationService';
import { updateResponse } from './UpdateManagerService';
import { userResponse, locationResponse } from './UserService';

const host = process.env.NODE_ENV === 'production' ? window.location.href.split('/')[2] : 'localhost:443';
const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds

let webSocket;
let inactivityTimer;

function startWebSocket() {
    webSocket = new W3CWebSocket('wss://' + host);
    webSocket.onopen = function() {
    };

    webSocket.onmessage = (e) => {
        // Handle incoming messages
        try {
            let message = JSON.parse(e.data);
            let requestType = Object.keys(message)[0]
            let data = message[requestType]
            switch (requestType) {
                case 'LoginResult':
                    authResponse(data);
                    resetInactivityTimer();
                    monitorUserActivity();
                    break;
                case 'verifyToken':
                    break;
                case 'verifyTokenResponse':
                    userResponse(data);
                    break;
                case 'verifyCode':
                    break;
                case 'verifyCodeResponse':
                    userResponse(data);
                    break;
                case 'getServerType':
                    break;
                case 'getServerTypeResponse':
                    mainResponse(data);
                    break;
                case 'sendVerificationCode':
                    break;
                case 'sendVerificationCodeResult':
                    authResponse(data);
                    break;
                case 'createCustomer':
                    break;
                case 'createCustomerResponse':
                    userResponse(data);
                    break;
                case 'deleteCustomer':
                    break;
                case 'deleteCustomerResponse':
                    userResponse(data);
                    break;
                case 'UserRequest':
                    break;
                case 'UserResponse':
                    userResponse(data);
                    break;
                case 'enableUser':
                    break;
                case 'enableUserResponse':
                    userResponse(data);
                    break;
                case 'findStation':
                    break;
                case 'findStationResponse':
                    mainResponse(data);
                    break;
                case 'updatePasswordExpiration':
                    break;
                case 'updatePasswordExpirationResponse':
                    userResponse(data);
                    break;
                case 'loadUserData':
                    break;
                case 'loadUserDataResponse':
                    userResponse(data);
                    break;
                case 'advancedSearch':
                    break;
                case 'advancedSearchResponse':
                    mainResponse(data);
                    break;
                case 'EntityRequest':
                    break;
                case 'EntityResponse':
                    stationResponse(data);
                    break;
                case 'createLocation':
                    break;
                case 'createLocationResponse':
                    stationResponse(data);
                    break;
                case 'saveEntry':
                    break;
                case 'saveEntryResponse':
                    stationResponse(data);
                    break;
                case 'saveNetworkSettings':
                    break;
                case 'saveNetworkSettingsResponse':
                    stationResponse(data);
                    break;
                case 'advancedFilter':
                    break;
                case 'advancedFilterResponse':
                    stationResponse(data);
                    break;
                case 'updateStationInformation':
                    break;
                case 'updateStationInformationResponse':
                    stationResponse(data);
                    break;
                case 'changeFirewallID':
                    break;
                case 'changeFirewallIDResponse':
                    stationResponse(data);
                    break;
                case 'updateVLAN':
                    break;
                case 'updateVLANResponse':
                    stationResponse(data);
                    break;
                case 'saveVLAN':
                    break;
                case 'saveVLANResponse':
                    stationResponse(data);
                    break;
                case 'saveProfileSettings':
                    break;
                case 'saveProfileSettingsResponse':
                    stationResponse(data);
                    break;
                case 'getEthers':
                    break;
                case 'getEthersResponse':
                    stationResponse(data);
                    break;
                case 'saveEthers':
                    break;
                case 'saveEthersResponse':
                    stationResponse(data);
                    break;
                case 'deleteVLAN':
                    break;
                case 'deleteVLANResponse':
                    stationResponse(data);
                    break;
                case 'requestPath':
                    break;
                case 'requestPathResponse':
                    stationResponse(data);
                    break;
                case 'deleteDevice':
                    break;
                case 'deleteDeviceResponse':
                    stationResponse(data);
                    break;
                case 'findDevice':
                    break;
                case 'findDeviceResponse':
                    stationResponse(data);
                    break;
                case 'createFirewall':
                    break;
                case 'createFirewallResponse':
                    stationResponse(data);
                    break;
                case 'updateUserInfo':
                    break;
                case 'updateUserInfoResponse':
                    userResponse(data);
                    break;
                case 'ChangeUpdateScheduleRequest':
                    break;
                case 'ChangeUpdateScheduleResponse':
                    updateResponse(data);
                    break;
                case 'loadFileData':
                    break;
                case 'loadFileDataResponse':
                    updateResponse(data);
                    break;
                case 'PlacesForUpdateManagerRequest':
                    break;
                case 'PlacesForUpdateManagerResponse':
                    updateResponse(data);
                    break;
                case 'DevicesForUpdateManagerRequest':
                    break;
                case 'DevicesForUpdateManagerResponse':
                    updateResponse(data);
                    break;
                case 'CreateUpdateScheduleRequest':
                    break;
                case 'CreateUpdateScheduleResponse':
                    updateResponse(data);
                    break;
                case 'deleteTechUser':
                    break;
                case 'deleteTechUserResponse':
                    userResponse(data);
                    break;
                case 'LocationRequest':
                    break;
                case 'LocationResponse':
                    locationResponse(data) ;
                    break;
                case 'ForgotPassword':
                    break;
                case 'ForgotPasswordResult':
                    forgotPasswordResponse(data) ;
                    break;
                case 'error':
                    // location.reload();
                    break;
                case 'Unauthorized':
                    if(data.message === 'Unauthorized'){
                        notification.error('You have been signed out. Redirecting to login page...', 5)
                        setTimeout(() => {
                            window.location.reload();         
                        }, 800);
                    } else {
                        notification.error("403 " + data.message, 5);
                    }
                    break;
                case 'disconnect':
                    // location.reload();
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    };


    webSocket.onerror = function(error) {
        console.error('WebSocket error:', error);
    };
}

function resetInactivityTimer() {
    clearInactivityTimer(); // Clear any existing timer
    inactivityTimer = setTimeout(disconnectUser, INACTIVITY_TIMEOUT); // Set a new timeout
}
function clearInactivityTimer() {
    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
        inactivityTimer = null;
    }
}

function disconnectUser() {
    // console.log('User inactive for 15 minutes. Disconnecting...');
    if (webSocket && webSocket.readyState === WebSocket.OPEN) {
        webSocket.close(1000, 'timeout');
        sessionStorage.setItem('showDisplayError', true)
        window.location.replace("/error?code=timeout");
    }
    // alert("You have been disconnected due to inactivity.");
}
// Monitor user activity and reset the inactivity timer on any interaction
function monitorUserActivity() {
    window.addEventListener('mousemove', resetInactivityTimer);
    window.addEventListener('keydown', resetInactivityTimer);
    window.addEventListener('click', resetInactivityTimer);
    window.addEventListener('touchstart', resetInactivityTimer); // For mobile
    // console.log("reset");
}


// Start monitoring and WebSocket connection
startWebSocket();

export {webSocket}
